<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <div>
        <h3 class="capitalize-first text-base font-semibold">
          {{ $t('global.what_payment_type') }}
        </h3>
      </div>
      <div class="flex flex-col gap-6">
        <div>
          <RadioCardComponent
            v-model="localPayment.payment_mode_id"
            :options="customPaymentModes"
            track-by="id"
            attribute-label="denomination"
          />
        </div>
        <div v-if="filteredPaymentModes.length > 1">
          <RadioCardComponent
            v-model="localPayment.payment_mode"
            :options="filteredPaymentModes"
            track-by="id"
            attribute-label="name"
            size="large"
            tinted
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadioCardComponent from '@c/BaseFormComponent/RadioCardComponent.vue'
import PaymentMode from '@/assets/enums/invoicing/PaymentMode'
import { mapGetters } from 'vuex'

export default {
  name: 'SelectType',
  components: { RadioCardComponent },
  props: {
    payment: {
      type: Object,
      required: true
    },
    customPaymentModes: {
      type: Array,
      required: true
    },
    hasDossier: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Array,
      required: true
    }
  },
  emits: ['update:payment'],
  computed: {
    ...mapGetters({
      payment_modes: 'metadata/getPaymentModesMetadata'
    }),
    localPayment: {
      get() {
        return this.payment
      },
      set(value) {
        this.$emit('update:payment', value)
      }
    },
    filteredPaymentModes() {
      // supprimer les types de payment obsolete mais les garder pour les paiements déjà avec ce type
      let basePaymentModes = this.payment_modes.filter((payment_mode) => {
        return (
          payment_mode.id == this.payment.payment_mode ||
          ![
            PaymentMode.INSURANCE,
            PaymentMode.HEALTH_MUTUAL,
            PaymentMode.OTHER
          ].includes(payment_mode.id)
        )
      })
      if (
        !this.payment.payment_mode_id ||
        this.payment.payment_mode_id === 'custom'
      ) {
        return basePaymentModes.filter((mode) => {
          if (!this.hasDossier && mode.id === 'LEV') {
            return false
          }
          return true
        })
      }
      // on filtre les paiments modes suivant la selection des paiement mode dans le custom paiment mode
      let customPaymentModes = this.customPaymentModes.find(
        (payment_mode) => payment_mode.id === this.payment.payment_mode_id
      )?.payment_modes
      return basePaymentModes?.filter((mode) =>
        customPaymentModes.includes(mode.id)
      )
    }
  },
  watch: {
    'payment.payment_mode_id'(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.filteredPaymentModes.length === 1) {
          this.localPayment.payment_mode = this.filteredPaymentModes[0].id
        } else {
          this.localPayment.payment_mode = null
        }
      }
    },
    'payment.payment_mode'(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (['CAS', 'CAR', 'CHE', 'CAU', 'CRN'].includes(newValue)) {
          this.localPayment.payment_status = 'REC'
        }
      }
    }
  }
}
</script>
